export default defineNuxtRouteMiddleware((to) => {
  const code = 'MZpkalY6'
  const router = useRouter()

  if (to.query.code === code)
    return router.push({ name: 'questionnaire', query: { code } })
  else
    return navigateTo('/')

  // if (to.query.code === 'MZpkalY6')
})
